export function getTooltipProps<T extends string>(
  tooltip: T | null,
  // TODO add clickable tooltips back
  clickable: boolean = false
) {
  if (!tooltip) {
    return {}
  }

  const content = `${tooltip[0].toUpperCase()}${tooltip.slice(1)}`

  return {
    "data-tooltip": content,
  } as const
}
